import {
    API,
    graphqlOperation
} from "aws-amplify";
import {
    getLocationsForOrg
} from "@/graphql/queries.js";
export const GetLocation = {
    data: () => ({
    
        GetLocationitems: []
        
    }),
    methods: {
        async GetLocation() {
            try {
               
                let result = await API.graphql(
                    graphqlOperation(getLocationsForOrg, {
                        input: {
                            organisation_id:
                              this.$store.getters.get_org_details[0].organisation_id,
                            location_status: "ACTIVE",
                          },
                    })
                );
                this.GetLocationitems = [];
                var response=result.data.getLocationsForOrg.data;
                this.GetLocationitems=response;
            } catch (err) {
                this.GetLocationitems = [];
                console.log("erro location", err);
                this.$store.commit("snackbar/showMessage", {
                    content: err.errors[0].message,
                    color: "red",
                  });
            }
        },
    }
}